import { render } from "./FuturesProfitActionNumberWidgetLayout.vue?vue&type=template&id=ee5eaf4c"
import script from "./FuturesProfitActionNumberWidgetLayout.vue?vue&type=script&lang=js"
export * from "./FuturesProfitActionNumberWidgetLayout.vue?vue&type=script&lang=js"
script.render = render

export default script